export enum DocumentGroupType {
    ShiftSchedule = 1
}
